import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Box,
  Typography,
  TablePagination,
  TextField,
  InputAdornment,
  IconButton,
  Tooltip
} from '@mui/material';
import { Search, Visibility } from '@mui/icons-material';

const CreateDataTable = ({data}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');

  // Filter data based on search term
  const filteredData = data.filter(row =>
    Object.values(row).some(value => {
      if (Array.isArray(value)) {
        return value?.some(item => 
          item?.toString()?.toLowerCase()?.includes(searchTerm.toLowerCase())
        );
      }
      return value?.toString()?.toLowerCase()?.includes(searchTerm.toLowerCase());
    })
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getChipColor = (colorType) => {
  switch(colorType) {
    case 'first': return 'primary';
    case 'second': return 'secondary'; 
    case 'third': return 'default';
    default: return 'default';
  }
};

  const renderLanguageChips = (languages, color = 'primary') => {
    return (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, maxWidth: 200 }}>
        {languages?.map((language, index) => (
          <Chip
            key={index}
            label={language}
            size="small"
            color={getChipColor('first')}
            variant="outlined"
            sx={{ fontSize: '0.75rem' }}
          />
        ))}
      </Box>
    );
  };

  const paginatedData = filteredData?.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Box sx={{ width: '100%', marginTop:"30px"  }}>

      <TableContainer component={Paper} elevation={3}>
        <Table sx={{ minWidth: 1200 }} aria-label="educational data table">
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              <TableCell><strong>State</strong></TableCell>
              <TableCell><strong>Board</strong></TableCell>
              <TableCell><strong>Segment</strong></TableCell>
              <TableCell><strong>Class</strong></TableCell>
              <TableCell><strong>First Languages</strong></TableCell>
              <TableCell><strong>Second Languages</strong></TableCell>
              <TableCell><strong>Third Languages</strong></TableCell>
              <TableCell><strong>Created</strong></TableCell>
              <TableCell><strong>Status</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((row) => (
              <TableRow 
                key={row.objectId}
                sx={{ 
                  '&:nth-of-type(odd)': { backgroundColor: '#fafafa' },
                  '&:hover': { backgroundColor: '#f0f0f0' },
                  opacity: row.isArchived ? 0.6 : 1
                }}
              >
                <TableCell>
                  <Typography variant="body2" fontWeight="medium">
                    {row.state_name}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">
                    {row.board_name}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">
                    {row.segment_name}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Chip 
                    label={row.class_name} 
                    size="small" 
                    color="secondary"
                    variant="filled"
                  />
                </TableCell>
                <TableCell>
                  {renderLanguageChips(row.FirstLanguages, 'primary')}
                </TableCell>
                <TableCell>
                  {renderLanguageChips(row.SecondLanguages, 'secondary')}
                </TableCell>
                <TableCell>
                  {renderLanguageChips(row.ThirdLanguages, 'default')}
                </TableCell>
                <TableCell>
                  <Typography variant="caption" color="text.secondary">
                    {formatDate(row.createdAt)}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Chip
                    label={row.isArchived ? 'Archived' : 'Active'}
                    size="small"
                    color={row.isArchived ? 'error' : 'success'}
                    variant="filled"
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {data.length === 0 && searchTerm && (
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography variant="body1" color="text.secondary">
            No results found for "{searchTerm}"
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default CreateDataTable;